import React, { useState, useEffect, useRef, Fragment } from 'react';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';

import { StyledField } from 'styles/form';

export default ({
  key,
  disabled,
  errors,
  label,
  name,
  onChange,
  options,
  required,
  touched,
  value,
  variant,
  disableNone,
  MenuProps,
  className,
}) => {
  const [labelWidth, setLabelWidth] = useState(0);
  const inputLabel = useRef(null);

  useEffect(() => {
    setLabelWidth(inputLabel.current.offsetWidth);
  }, []);

  return (
    <Fragment key={key}>
      <StyledField fullWidth variant={variant} className={className}>
        <InputLabel
          ref={inputLabel}
          error={errors && touched}
          required={required}
        >
          {label}
        </InputLabel>
        <Select
          disabled={disabled}
          error={errors && touched}
          labelWidth={labelWidth}
          name={name}
          onChange={onChange}
          required={required}
          value={value}
          MenuProps={MenuProps}
        >
          {!disableNone && (
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
          )}

          {options.map(({ value: optionValue, label: optionLabel }) => (
            <MenuItem key={optionValue} value={optionValue}>
              {optionLabel}
            </MenuItem>
          ))}
        </Select>
        {errors && touched && (
          <FormHelperText error={errors}>field is required</FormHelperText>
        )}
      </StyledField>
    </Fragment>
  );
};
